<template>
  <div class="mpartner">
    <h1>专注仿真 - 想用户之所想</h1>
    <p>完美工匠精神，为客户持续创造价值</p>
    <div class="mpartner-box">
      <div class="mpartner-box-img">
        <div>
          <img src="http://bernouly.oss-cn-beijing.aliyuncs.com/images/partner/partner1.png" alt>
        </div>
      </div>
      <div class="mpartner-box-img">
        <div>
          <img src="http://bernouly.oss-cn-beijing.aliyuncs.com/images/partner/partner2.png" alt>
        </div>
      </div>
      <div class="mpartner-box-img">
        <div>
          <img src="http://bernouly.oss-cn-beijing.aliyuncs.com/images/partner/partner3.png" alt>
        </div>
      </div>
      <div class="mpartner-box-img">
        <div>
          <img src="http://bernouly.oss-cn-beijing.aliyuncs.com/images/partner/partner4.png" alt>
        </div>
      </div>
      <div class="mpartner-box-img">
        <div>
          <img src="http://bernouly.oss-cn-beijing.aliyuncs.com/images/partner/partner5.png" alt>
        </div>
      </div>
      <div class="mpartner-box-img">
        <div>
          <img src="http://bernouly.oss-cn-beijing.aliyuncs.com/images/partner/partner6.png" alt>
        </div>
      </div>
      <div class="mpartner-box-img">
        <div>
          <img src="http://bernouly.oss-cn-beijing.aliyuncs.com/images/partner/partner7.png" alt>
        </div>
      </div>
      <div class="mpartner-box-img">
        <div>
          <img src="http://bernouly.oss-cn-beijing.aliyuncs.com/images/partner/partner8.png" alt>
        </div>
      </div>
      <div class="mpartner-box-img">
        <div>
          <img src="http://bernouly.oss-cn-beijing.aliyuncs.com/images/partner/partner9.png" alt>
        </div>
      </div>
      <div class="mpartner-box-img">
        <div>
          <img src="http://bernouly.oss-cn-beijing.aliyuncs.com/images/partner/partner10.png" alt>
        </div>
      </div>
      <div class="mpartner-box-img">
        <div>
          <img src="http://bernouly.oss-cn-beijing.aliyuncs.com/images/partner/partner11.png" alt>
        </div>
      </div>
      <div class="mpartner-box-img">
        <div>
          <img style="width: 1.2rem;height: .3rem;" src="http://bernouly.oss-cn-beijing.aliyuncs.com/images/partner/partner12.png" alt>
        </div>
      </div>
      <div class="mpartner-box-img">
        <div>
          <img src="http://bernouly.oss-cn-beijing.aliyuncs.com/images/partner/partner13.png" alt>
        </div>
      </div>
      <div class="mpartner-box-img">
        <div>
          <img src="http://bernouly.oss-cn-beijing.aliyuncs.com/images/partner/partner14.png" alt>
        </div>
      </div>
      <div class="mpartner-box-img">
        <div>
          <img src="http://bernouly.oss-cn-beijing.aliyuncs.com/images/partner/partner15.png" alt>
        </div>
      </div>
      <div class="mpartner-box-img">
        <div>
          <img src="http://bernouly.oss-cn-beijing.aliyuncs.com/images/partner/partner16.png" alt>
        </div>
      </div>
      <div class="mpartner-box-img">
        <div>
          <img src="http://bernouly.oss-cn-beijing.aliyuncs.com/images/partner/partner17.png" alt>
        </div>
      </div>
      <div class="mpartner-box-img">
        <div>
          <img src="http://bernouly.oss-cn-beijing.aliyuncs.com/images/partner/partner18.png" alt>
        </div>
      </div>
      <div class="mpartner-box-img">
        <div>
          <img src="http://bernouly.oss-cn-beijing.aliyuncs.com/images/partner/partner19.png" alt>
        </div>
      </div>
      <div class="mpartner-box-img">
        <div>
          <img src="http://bernouly.oss-cn-beijing.aliyuncs.com/images/partner/partner20.png" alt>
        </div>
      </div>
      <div class="mpartner-box-img">
        <div>
          <img style="width: 1.2rem;height: .3rem;" src="http://bernouly.oss-cn-beijing.aliyuncs.com/images/partner/partner21.png" alt>
        </div>
      </div>
      <div class="mpartner-box-img">
        <div>
          <img style="width: 1.2rem;height: .3rem;" src="http://bernouly.oss-cn-beijing.aliyuncs.com/images/partner/partner22.png" alt>
        </div>
      </div>
      <div class="mpartner-box-img">
        <div>
          <img style="width: 1.2rem;height: .3rem;" src="http://bernouly.oss-cn-beijing.aliyuncs.com/images/partner/partner23.png" alt>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  components: {},
  data() {
    return {};
  },
  watch: {},
  created() {},
  mounted() {},
  methods: {}
};
</script>
<style>
.mpartner {
  margin-bottom: 0.4rem;
  background: #fff;
}
.mpartner h1 {
  font-size: 0.36rem;
  color: #0055d3;
  padding-top: 0.3rem;
  text-align: center;
}
.mpartner p {
  font-size: 0.2rem;
  color: #999;
  padding-top: 0.14rem;
  text-align: center;
}
.mpartner-box {
  padding: 0.4rem;
  display: flex;
  flex-wrap: wrap;
}
.mpartner-box-img {
    background: #f6f6f6;
    position: relative;
    border: .04rem solid #fff;
    width: 2.14rem;
    height: 2.14rem;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
}
.mpartner-box-img img{
    width: 1rem;
    height: 1rem;
}
</style>